var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-field-boolean"},[_c('q-toggle',_vm._g(_vm._b({},'q-toggle',_vm.computedAttrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }